import { useNotification } from 'contexts/NotificationContext';
import { useEffect, useRef } from 'react';

export default function MusicPlayer() {
	const audioRef = useRef(null);
	const { isOn } = useNotification();

	const isMusicEnabled =
		typeof window !== 'undefined' &&
		localStorage.getItem('background_music') === '1';

	const isOnRef = useRef(isOn);

	useEffect(() => {
		isOnRef.current = isOn;
	}, [isOn]);

	useEffect(() => {
		const audio = audioRef.current;
		if (!audio) return;

		if (isOn && isMusicEnabled) {
			audio.play().catch(() => { });
		} else {
			audio.pause();
		}
	}, [isOn, isMusicEnabled]);

	useEffect(() => {
		const audio = audioRef.current;
		if (!audio) return;

		const bg = localStorage.getItem('background_music') === '1';

		if (bg && isOnRef.current) {
			audio.play().catch(() => { });
		}
	}, []);

	useEffect(() => {
		const audio = audioRef.current;
		if (!audio) return;

		const handleVisibility = () => {
			if (document.hidden) {
				audio.pause();
			}
		};

		document.addEventListener('visibilitychange', handleVisibility);

		return () => {
			document.removeEventListener('visibilitychange', handleVisibility);
		};
	}, []);

	useEffect(() => {
		const audio = audioRef.current;
		if (!audio) return;

		const unlockAndPlay = () => {
			const bg = localStorage.getItem('background_music') === '1';
			const on = isOnRef.current;

			if (!bg || !on) return;

			audio.play().catch(() => { });
		};

		document.addEventListener('click', unlockAndPlay);
		document.addEventListener('touchstart', unlockAndPlay);

		return () => {
			document.removeEventListener('click', unlockAndPlay);
			document.removeEventListener('touchstart', unlockAndPlay);
		};
	}, []);

	return (
		<audio
			ref={audioRef}
			muted={false}
			loop
			preload="metadata"
			playsInline
			src={
				process.env.REACT_APP_DOMAIN_MUSIC +
				'/uploads/absounds-uplifting-positive-kids-game-484998.mp3'
			}
		/>
	);
}